import React from 'react';
import { Link } from 'react-scroll';

const NavBar = (props) => {
    const {
        sections,
    } = props;

    return (
        <header className='nav'>
            <img src={require('../../assets/logo.svg').default} className='nav_logo' alt='nav logo' />
            <div className='nav_sections_container'>
                {sections?.map((item) =>
                    <nav className='nav_sections'>
                        <ul>
                            <li>
                                <Link activeClass='active' smooth spy to={item.url}>
                                    {item.name?.toUpperCase()}
                                </Link>
                            </li>
                        </ul>
                    </nav>
                )}
            </div>
        </header>
    )
}

export default NavBar;